import { render, staticRenderFns } from "./MenuEditImageButton.vue?vue&type=template&id=2c6f2b2d&"
import script from "./MenuEditImageButton.vue?vue&type=script&lang=ts&"
export * from "./MenuEditImageButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports